// _paragraphAnimations.js

import { getGSAP } from './_gsap.js';

function splitTextIntoLines(element) {
  console.log("Splitting text for element:", element);
  const text = element.innerText;
  console.log("Text content:", text);
  if (!text.trim()) {
    console.warn("Element is empty or contains only whitespace");
    return [];
  }

  const words = text.split(/\s+/);
  console.log("Words:", words);
  const lines = [];
  let currentLine = '';

  element.style.visibility = 'hidden';
  const testDiv = document.createElement('div');
  testDiv.style.position = 'absolute';
  testDiv.style.whiteSpace = 'nowrap';
  testDiv.style.font = window.getComputedStyle(element).font;
  document.body.appendChild(testDiv);

  words.forEach((word, index) => {
    const testWord = word + (index < words.length - 1 ? ' ' : '');
    testDiv.textContent += testWord;
    
    if (testDiv.offsetWidth > element.offsetWidth) {
      lines.push(currentLine.trim());
      currentLine = testWord;
      testDiv.textContent = testWord;
    } else {
      currentLine += testWord;
    }
  });

  if (currentLine) {
    lines.push(currentLine.trim());
  }

  document.body.removeChild(testDiv);
  console.log("Split lines:", lines);

  element.innerHTML = lines.map(line => `<span class="split-line">${line}</span>`).join('');
  element.style.visibility = 'visible';

  const splitLines = element.querySelectorAll('.split-line');
  console.log("Number of split-line elements:", splitLines.length);
  return splitLines;
}

export function initParagraphAnimations() {
  const gsap = getGSAP();

  function animateParagraphs() {
    const elements = document.querySelectorAll('[data-animation="paragraph-lines"]');

    elements.forEach(element => {
      const lines = splitTextIntoLines(element);

      gsap.set(lines, { opacity: 0, y: 50 });

      gsap.to(lines, {
        duration: 0.8,
        opacity: 1,
        y: 0,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });
    });
  }

  // Si le DOM est déjà chargé, exécuter immédiatement
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    animateParagraphs();
  } else {
    // Sinon, attendre que le DOM soit chargé
    document.addEventListener('DOMContentLoaded', animateParagraphs);
  }
}